import React from "react";
import SelectableTable from "../SelectableTable/Main.js";
import InputFormTable from "../InputFormTable/Main.js";
import update from "immutability-helper";
import { connect } from "react-redux";
import { openSwAction } from "../../redux/ui/actions";
import { changeSwModeAction, changeInPredictAction, finLrnAction } from "../../redux/app/actions";
import Sw from "../common/Sw_Pop.js";
import { getBoolListForSelectedEnv } from "./Name.js";

const mapStateToProps = (state) => {
    return {};
};

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.closeSw = this.closeSw.bind(this);
        this.saveWithName = this.saveWithName.bind(this);
        this.overwriteSave = this.overwriteSave.bind(this);
        this.noSave = this.noSave.bind(this);
    }

    /*
     * 名前をつけて保存
     * @since ando 2024-04-02
     */
    saveWithName() {}

    /*
     * 上書き保存
     * @since ando 2024-04-02
     */
    overwriteSave() {}

    /*
     * 保存しないで閉じる
     * @since ando 2024-04-02
     */
    noSave() {
        window.location.href = "https://activation.gmlabo.jp";
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2020-09-09
     */
    closeSw() {
        this.props.dispatch(openSwAction(null));
        this.props.dispatch(changeSwModeAction(0));
    }

    render() {
        return (
            <div className="LoaderWrap2 l-center">
                <Sw title="ログアウト" focusName="logout">
                    <div className="l-flex">
                        <p>
                            プロジェクトを保存しますか？
                            <br />
                        </p>
                    </div>
                    <div className="l-right l-mtM">
                        <button className="sBtn" onClick={this.saveWithName}>
                            名前をつけて保存
                        </button>
                        <button className="sBtn" onClick={this.overwriteSave}>
                            上書き保存
                        </button>
                        <button className="sBtn" onClick={this.noSave}>
                            保存しないで終了
                        </button>
                    </div>
                    <div className="l-right l-mtM">
                        <button className="cBtn" onClick={this.closeSw}>
                            キャンセル
                        </button>
                    </div>
                </Sw>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Main);
